import { createSelector, createSlice } from '@reduxjs/toolkit';
const initialState = {
  errorMessages: {},
  showAllErrors: false // set to true when confirm payment button is clicked
};
const getErrorMessageStore = state => state.errorMessages;
export const getErrorMessages = createSelector([getErrorMessageStore], errorMessages => errorMessages.errorMessages);
export const getShowAllErrors = createSelector([getErrorMessageStore], errorMessages => errorMessages.showAllErrors);
export const errorMessagesSlice = createSlice({
  name: 'errorMessages',
  initialState,
  reducers: {
    setErrorMessages(state, action) {
      Object.entries(action.payload).forEach(([key, value]) => {
        state.errorMessages[key] = {
          isError: value.isError,
          customFormFieldLabel: value.customFormFieldLabel,
          totalsOptions: value.totalsOptions
        };
      });
    },
    setShowAllErrors(state, action) {
      state.showAllErrors = action.payload;
    },
    clearCardErrors(state) {
      const cardErrorKeys = ['emptyNameOnCard', 'emptyPostalCode', 'emptyBillingState', 'emptyBillingStateProvinceRegion', 'emptyBillingAddressLine1', 'emptyBillingCity', 'emptyBillingCityTownVillage', 'emptyBillingPostalCode', 'emptyBillingCountry'];
      cardErrorKeys.forEach(key => {
        state.errorMessages[key] = {
          isError: false
        };
      });
    },
    clearBankDebitErrors(state) {
      state.errorMessages['emptyAccountHolderName'] = {
        isError: false
      };
    }
  }
});
export const {
  setErrorMessages,
  setShowAllErrors,
  clearCardErrors,
  clearBankDebitErrors
} = errorMessagesSlice.actions;
export default errorMessagesSlice.reducer;